import { Col, Row } from 'reactstrap';
import { useEffect, useState } from 'react';
import { Loading } from './Loading';
import { Hero } from './Hero';
import { useFetchWrapper } from '../../hooks/useFetchWrapper';
import { ErrorContact } from '../ContactUs/ErrorContact';
import { clientConfig } from '../../utilities/configService';
import { ContentBlock } from './Content/ContentBlock';
import { ContentBody } from './Content/ContentBody';
import { useAPIErrorContext } from '../../contexts/apiErrorContext';


interface IProps {
    includeHero: boolean,
    showContactForm: boolean
}

export const ErrorPage: React.FC<IProps> = ({ includeHero, showContactForm }) => {
    const fetchWrapper = useFetchWrapper();
    const { addError } = useAPIErrorContext();
    const [apiServerAvailable, setAPIServerAvailable] = useState(false);
    const [pingLoading, setPingLoading] = useState(true);

    useEffect(() => {
        const pingAPI = () => {
            fetchWrapper.get('ping')
                .then((data) => {
                    if (data.success) {
                        setAPIServerAvailable(data.success);
                    }
                    else {
                        setAPIServerAvailable(false);
                        setPingLoading(false);
                        addError("API Ping failure, server not available.", "");
                    }
                }).catch((error: any) => {
                    setAPIServerAvailable(false);
                    setPingLoading(false);
                    addError("API Ping failure, server not available.", error); 
                });;
        };
        if (showContactForm) {
            setPingLoading(true);
            pingAPI();
        }
    }, [showContactForm]);

    useEffect(() => {
        if (apiServerAvailable) {
            setPingLoading(false);
        }
    }, [apiServerAvailable]);

    if (!pingLoading) {
        return (
            <div className="errorPage">
                {includeHero ? (
                    <Hero pageTitle="Oops" />
                ) : ('')}
                <ContentBlock className="errorContentBlock">
                    <ContentBody>
                        {showContactForm && apiServerAvailable ? (
                            <Row className="errorFormContainer">
                                <Col className="loadingTextCol">
                                    <Row>
                                        <Col>
                                            <h3 className="css_heading bold">
                                                Our site encountered an error when attempting to load content. Please wait a moment and then reload this page.
                                                If this error persists, please contact our program team for assistance at&nbsp;
                                                <a href={`mailto:${clientConfig?.HELP_EMAIL_ADDRESS}`}>{clientConfig?.HELP_EMAIL_ADDRESS}</a>&nbsp;
                                                or complete the below form, and we will reach out as soon as possible.
                                            </h3>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <ErrorContact />
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        ) : (
                            <div>
                                <Row className="loadingSpinnerRow">
                                    <Col className="loadingSpinnerCol">
                                            <div className="loadingImage text-align-center">
                                            <img src="/assets/images/chaosMonkey.png" alt="Site Unavailable" width="200" height="200" />
                                        </div>
                                    </Col>
                                </Row>
                                <Row className="loadingTextRow">
                                    <Col className="loadingTextCol">
                                        <h3 className="css_heading bold">Our site encountered an error when attempting to load content.
                                            Please wait a moment and then reload this page.
                                            If this error persists, please contact our program team for assistance at&nbsp;
                                            <a href={`mailto:${clientConfig?.HELP_EMAIL_ADDRESS}`}>{clientConfig?.HELP_EMAIL_ADDRESS}</a>.</h3>

                                    </Col>
                                </Row>
                            </div>
                        )}
                    </ContentBody>
                </ContentBlock>
            </div >
        );
    } else {
        return (
            <Loading showContent={true} includeHero={true} />
        );
    }
};
